import { Image as ImageIcon, Volume2 } from 'lucide-react';

/**
 * Picture or speaker, for a place that names a media option without room to show the media.
 *
 * Its own file because two very different callers need it and neither may own it: the MCQ and
 * Ordering editors draw it beside a media row, and the shared chip derivations bracket a chip's
 * label with it (`[Diagram A]` plus this glyph) so a teacher can tell "the option labelled Diagram
 * A" from "the option whose text is Diagram A". Those derivations live in `lib/`, and `lib/` may
 * reach a shared component but never a block — so leaving this inside `mcq-block.tsx` is what a
 * cycle looks like before it happens.
 *
 * `aria-hidden`: the label beside it already says the option is media, in text.
 */
export function MediaKindIcon({ kind, className }: { kind: 'image' | 'audio'; className?: string }) {
  return kind === 'image'
    ? <ImageIcon className={className} aria-hidden='true' />
    : <Volume2 className={className} aria-hidden='true' />;
}
